import ReceiptPrinterEncoder from '@point-of-sale/receipt-printer-encoder';
import qz from 'qz-tray';
import moment from 'moment';
import { POST, POST_JSON } from './ConsumeApiController';
import WebsiteRoutes from '../apiRoutes/WebsiteRoutes';

/**
 * Función Auxiliar: Arma el diseño unificado del Ticket usando ESC/POS
 */
function buildTicketDesign(merchant, event, tickets) {
    let encoder = new ReceiptPrinterEncoder({
        columns: 32 // Ancho estándar para impresoras térmicas pequeñas (58mm)
    });

    encoder.initialize();

    for (const ticket of tickets) {
        // --- CABECERA ---
        encoder.align('center');
        encoder.bold(true);
        encoder.text(merchant ? merchant.toUpperCase() : 'COMERCIO');
        encoder.bold(false);
        encoder.newline();
        
        encoder.line('--------------------------------'); 
        
        // --- EVENTO ---
        encoder.size(2, 2); 
        encoder.text(event || 'EVENTO QUD');
        encoder.size(1, 1); 
        encoder.newline();
        
        encoder.line('--------------------------------');
        
        // --- DATOS DEL BOLETO ---
        encoder.align('left');
        encoder.text('TIPO: ');
        encoder.bold(true);
        
        encoder.text(ticket.section || 'ENTRADA GENERAL');
        encoder.bold(false);
        encoder.newline();

        if (ticket.row && ticket.seat) {
            encoder.align('center');
            encoder.newline();
            encoder.size(2, 2);
            encoder.text(`F: ${ticket.row} - A: ${ticket.seat}`);
            encoder.size(1, 1);
            encoder.newline();
        }

        encoder.newline();

        // --- CÓDIGO QR (NATIVO, COMO LO TENÍAS ANTES) ---
        encoder.align('center');
        const qrContent = ticket.uuid || ticket.ticket_uuid || 'SIN-UUID';
        
        encoder.qrcode(qrContent, { model: 1, size: 8, errorlevel: 'h' }); 
        //encoder.newline();
        
        // Imprimimos el código abajo para validación manual
        encoder.text(qrContent);
        encoder.newline(2);

        // --- PIE DE PÁGINA ---
        encoder.align('center');
        encoder.text(`Emitido: ${moment().format('DD/MM/YYYY HH:mm')}`);
        encoder.newline();
        encoder.bold(true);
        encoder.text('Powered bY QUD');
        encoder.bold(false);
        
        // Espacio para arrancar el papel térmico
        encoder.newline(4); 
    }

    return encoder.encode();
}

// ==========================================
// MÉTODOS DE IMPRESIÓN ACTUALIZADOS
// ==========================================

export async function printWithRawBT(merchant, event, tickets) {
    try {
        const encodedContent = buildTicketDesign(merchant, event, tickets);
        
        // CONVERSIÓN SEGURA A BASE64
        let binary = '';
        const bytes = new Uint8Array(encodedContent);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        const base64Content = window.btoa(binary);
      
        const rawBTUrl = `rawbt:base64,${base64Content}`;
        window.location.href = rawBTUrl;
        
    } catch (error) {
        console.error("Error armando el ticket RawBT:", error);
    }
}

export async function printWithWebBluetooth(merchant, event, tickets) {
    try {
        const encodedContent = buildTicketDesign(merchant, event, tickets);
        const buffer = new Uint8Array(encodedContent).buffer;

        const device = await navigator.bluetooth.requestDevice({
            acceptAllDevices: true, 
            optionalServices: ['00001101-0000-1000-8000-00805f9b34fb'] 
        });

        const server = await device.gatt.connect();
        const service = await server.getPrimaryService('00001101-0000-1000-8000-00805f9b34fb');
        const characteristic = await service.getCharacteristic('00001101-0000-1000-8000-00805f9b34fb');

        await characteristic.writeValue(buffer);
        console.log('Impresión enviada con éxito');
    } catch (error) {
        console.error('Error al imprimir por Web Bluetooth:', error);
    }
}

export async function printWithQZTrayFunction(merchant, event, tickets, printer) {
    console.log('Tickets para impresion ===> ', tickets);
    
    try {
        const encodedContent = buildTicketDesign(merchant, event, tickets);
        const base64Data = window.btoa(String.fromCharCode(...new Uint8Array(encodedContent)));

        await qz.websocket.connect();
        const config = qz.configs.create(printer);
        await qz.print(config, [{ type: 'raw', format: 'base64', data: base64Data }]);
        console.log("Impresión realizada con éxito");
    } catch (error) {
        console.error("Error de impresión QZ Tray:", error);
    } finally {
        if (qz.websocket.isActive()) {
            qz.websocket.disconnect();
        }
    }
}

export async function UploadExcel(excel_file){
    let response = await POST_JSON(WebsiteRoutes.Eventos.Tickets.batch,{excel_file});
    return response;
}